import { CONFIG } from '../constants/config';

// Fetch with timeout utility
export const fetchWithTimeout = async (url, timeout = CONFIG.API_TIMEOUT) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  
  try {
    const response = await fetch(url, { signal: controller.signal });
    clearTimeout(timeoutId);
    return response;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      throw new Error('Request timeout');
    }
    throw error;
  }
};

// Weather API URL builder
export const buildWeatherUrl = (lat, lon, params = {}) => {
  const baseUrl = 'https://api.open-meteo.com/v1/forecast';
  const defaultParams = {
    latitude: lat,
    longitude: lon,
    temperature_unit: 'fahrenheit',
    wind_speed_unit: 'mph',
    timezone: 'America/New_York'  // Eastern Time (EST/EDT)
  };
  
  const queryParams = new URLSearchParams({ ...defaultParams, ...params });
  return `${baseUrl}?${queryParams.toString()}`;
};

// NOAA API URL builders
export const buildTideUrl = (station, beginDate, endDate) => {
  const baseUrl = 'https://api.tidesandcurrents.noaa.gov/api/prod/datagetter';
  const params = {
    begin_date: beginDate,
    end_date: endDate,
    station: station,
    product: 'high_low',
    datum: 'MLLW',  // Mean Lower Low Water - standard for tide predictions
    time_zone: 'lst_ldt',  // Local Standard Time/Local Daylight Time (Eastern for Cape San Blas)
    units: 'english',
    format: 'json'
  };
  
  const queryParams = new URLSearchParams(params);
  return `${baseUrl}?${queryParams.toString()}`;
};

// Build URL for current water level data
export const buildWaterLevelUrl = (station) => {
  const baseUrl = 'https://api.tidesandcurrents.noaa.gov/api/prod/datagetter';
  const params = {
    date: 'latest',
    station: station,
    product: 'water_level',
    datum: 'MLLW',
    units: 'english',
    time_zone: 'lst_ldt',
    format: 'json'
  };
  
  const queryParams = new URLSearchParams(params);
  return `${baseUrl}?${queryParams.toString()}`;
};

export const buildWaterTempUrl = (station) => {
  const baseUrl = 'https://api.tidesandcurrents.noaa.gov/api/prod/datagetter';
  const params = {
    date: 'latest',
    station: station,
    product: 'water_temperature',
    units: 'english',
    time_zone: 'lst_ldt',  // Local Standard Time/Local Daylight Time (Eastern for Cape San Blas)
    format: 'json'
  };
  
  const queryParams = new URLSearchParams(params);
  return `${baseUrl}?${queryParams.toString()}`;
};